module.exports = __webpack_public_path__ + "img/examen_francais.954c87ce.png";